import type React from 'react';
import { memo } from 'react';

import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import * as st from './styles.module.scss';

type Props = {
	start?: string;
};

export const StartTime: React.FC<Props> = memo(({ start }) => {
	return (
		<div className={st.time} onMouseOver={(e) => e.stopPropagation()}>
			{start && format(parseISO(start), 'HH:mm')}
		</div>
	);
});
